import { Button, ErrorMessage, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { CANCEL_ACTION_LABEL } from "../labels";

export type CancelDdqModalProps = {
  errorMessage: string | null;
  isSubmitting: boolean;
  onHide: () => void;
  onConfirm: () => void;
};

export const CancelDdqModal = ({
  errorMessage,
  isSubmitting,
  onHide,
  onConfirm,
}: CancelDdqModalProps) => (
  <ModalV2 show onHide={onHide} title="Cancel DDQ?" size="small" data-testid="ddq-cancel-modal">
    <ModalV2.Body>
      <Flex flexDirection="column" gap={SPACING.LARGE}>
        <Text variant="secondary-md">This will cancel the DDQ and close the ticket.</Text>
        {errorMessage && (
          <ErrorMessage data-testid="ddq-cancel-error">{errorMessage}</ErrorMessage>
        )}
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="row" gap={SPACING.SMALL} justifyContent="flex-end">
        <Button variant="neutral" onClick={onHide} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="danger"
          isLoading={isSubmitting}
          disabled={isSubmitting}
          onClick={onConfirm}
          data-testid="ddq-cancel-confirm"
        >
          {CANCEL_ACTION_LABEL}
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
